<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import PayCenter from './views/PayCenter.vue'
// import VipCenter from './views/VipCenter.vue'

export default {
  name: 'App'
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
} */
</style>